<script lang="ts">
    import { onMount } from 'svelte'
    import type { Person } from '../../../modules/eventsApi/persons/person'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import dayjs from 'dayjs'
    import 'dayjs/locale/pt-br'
    import type { BalanceResult } from '../../../modules/posApi/balance-results/balance-result'
    import { faUser } from '@fortawesome/free-solid-svg-icons'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    dayjs.locale('pt-br')

    let show = false

    let grid: GridClass = null
    async function load() {
        if (show) return
        show = true
        let data: BalanceResult[] = await window.api.pos.balanceResults.getAll()
        data = await window.api.utils.utils.assignPersonsFromObject(data)
        data = await window.api.utils.utils.assignServicesFromObject(data)
        console.log('data-in', data)
        //
        grid = new GridClass()
        grid.title = 'Pessoas com saldo de serviços'
        //grid.subtitle = 'Selecione o período onde deve'
        grid.cols.push(new GridCol({ content: 'Nome' }))
        grid.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        grid.cols.push(new GridCol({ content: 'E-Mail', type: GridColTypeEnum.email }))
        grid.cols.push(new GridCol({ content: 'Serviço' }))
        //grid.cols.push(new GridCol({ content: 'Comprado', type: GridColTypeEnum.float }))
        //grid.cols.push(new GridCol({ content: 'Consumido', type: GridColTypeEnum.float }))
        grid.cols.push(new GridCol({ content: 'Agendado', type: GridColTypeEnum.float }))
        grid.cols.push(new GridCol({ content: 'A agendar', type: GridColTypeEnum.float }))
        grid.cols.push(new GridCol({ type: GridColTypeEnum.button }))
        for (const balance of data) {
            if (balance.scheduled + balance.unscheduled <= 0) continue
            let btnPerson: GridButton = new GridButton({
                callback: () => window.person('show', balance.personId),
                icon: faUser,
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: balance.person?.name })
            line.slots.push({ content: balance.person?.phone })
            line.slots.push({ content: balance.person?.email })
            line.slots.push({ content: balance.service?.name || '-' })
            //line.slots.push({ content: el.purchased })
            //line.slots.push({ content: el.consumed })
            line.slots.push({ content: balance.scheduled })
            line.slots.push({ content: balance.unscheduled })
            line.slots.push({ content: [btnPerson] })
            grid.lines.push(line)
        }
        console.log('grid', grid)
        grid = grid
        show = false
    }

    onMount(() => {
        load()
    })
</script>

<div class="relat-body">
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
